import React, { useCallback, useEffect, useMemo } from "react";
import { useDatalayer } from "../hooks/use-datalayer";

type DatalayerModalContextType = { action: string };

export const datalayerModalContext =
    React.createContext<DatalayerModalContextType>(null);

type Props = React.HTMLAttributes<HTMLDivElement> & {
    type: string;
    name: string;
    children?: React.ReactNode;
    open: boolean;
    onClose: VoidFunction;
    as?: React.ElementType<{
        open: boolean;
        onClose: VoidFunction;
        children: React.ReactNode;
    }>;
};

export const DatalayerModal: React.FC<Props> = (props: Props) => {
    const { push } = useDatalayer();
    const {
        open,
        onClose,
        type,
        name,
        children,
        as: Component = "div",
        ...rest
    } = props;
    const action = useMemo(() => `Modal - ${type} - ${name}`, []);
    useEffect(() => {
        if (props.open) {
            push({
                event: "virtualEvent",
                category: "Pacifico - Seguro Vida Ley",
                action: `Modal - ${type} - ${name}`,
                label: "Visualizar modal",
            });
        }
    }, [open]);
    const internalOnClose = useCallback(() => {
        push({
            event: "virtualEvent",
            category: "Pacifico - Seguro Vida Ley",
            action: `Modal - ${props.type} - ${props.name}`,
            label: "Cerrar modal",
        });
        onClose();
    }, [onClose]);
    return (
        <datalayerModalContext.Provider value={{ action }}>
            <Component
                data-testid="DatalayerModal"
                open={open}
                onClose={internalOnClose}
                {...(rest as any)}
            >
                {children}
            </Component>
        </datalayerModalContext.Provider>
    );
};
